// extracted by mini-css-extract-plugin
export default {"loader":"SmallLoader_loader__zurvD","rotation":"SmallLoader_rotation__F8n3-"};